import { amountSources, entryPoints, eventActions, eventContents, eventLabels, productNames } from './constants'
import { buildPaymentContext, sendInteractionGtm, sendPageviewGtm, setEntryPoint, toCd1 } from './helpers'
import { paymentLoginMailAddGtm, paymentPromocodeAddGtm, paymentQrShowGtm } from './payment'
import { EntryPoint } from './types'

const steamProduct = {
  productName: productNames.steam,
}

type SteamEntry = { entry?: EntryPoint }

type SteamQrParams = SteamEntry & {
  amount: string
  requestId: string
  transactionId: string
}

const steamParams = (params: SteamEntry = {}) => ({
  ...steamProduct,
  entry: params.entry,
})

const steamContext = (params: SteamEntry & { amount?: string } = {}) =>
  buildPaymentContext({
    content: eventContents.servisy,
    productName: productNames.steam,
    entry: params.entry,
    amount: params.amount,
  })

// Показ страницы «Пополнение баланса Steam»
export const steamPageShowGtm = (params?: SteamEntry) =>
  sendPageviewGtm({
    eventLabel: eventLabels.rekvizity,
    ...steamContext(params),
  })

// Клик на рекламный баннер на странице Steam
export const steamBannerClickGtm = (bannerName: string) => {
  setEntryPoint(entryPoints.reklamnyiBanner)

  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.reklamnyiBanner,
    eventContent: eventContents.rekvizity,
    bannerName: toCd1(bannerName),
  })
}

// Успешный ввод логина
export const steamLoginAddGtm = (params?: SteamEntry) =>
  paymentLoginMailAddGtm(eventContents.servisy, steamParams(params))

// Ввод суммы
export const steamSumAddGtm = (amount: string, params?: SteamEntry) =>
  sendInteractionGtm({
    eventAction: eventActions.formAdd,
    eventLabel: eventLabels.sum,
    ...steamContext({ ...params, amount }),
  })

// Ввод промокода
export const steamPromocodeAddGtm = (params?: SteamEntry) =>
  paymentPromocodeAddGtm(eventContents.servisy, steamParams(params))

// Клик на подарочную карту
export const steamGiftCardClickGtm = (amount: string, params?: SteamEntry) =>
  sendInteractionGtm({
    eventAction: eventActions.elementClick,
    eventLabel: eventLabels.podarochnayaKarta,
    ...steamContext({ ...params, amount }),
  })

const withRekvizity = <T extends object>(params: T) => ({
  ...params,
  amountSource: amountSources.rekvizity,
})

// Показ QR-кода для оплаты СБП
export const steamQrShowGtm = (params: SteamQrParams) =>
  paymentQrShowGtm(eventContents.servisy, { ...steamProduct, ...withRekvizity(params) })
